module.exports = __webpack_public_path__ + "fca9d7ec0349a7594ff99218bce319a9.svg";